import {
  POST_SCHOOL_REPORTS_LIST,
  convertResult,
  convertParams,
} from 'app/common/api/requests/food/schools/reports_list/post'

import { DesktopReportsInOrgMutateParams } from 'app/common/types/reports/desktop'

import { useCommonDataProvider, CommonDataOptions } from 'app/dataProviders/useCommonDataProvider'

const defaultState: boolean = false

type Op = CommonDataOptions<boolean, DesktopReportsInOrgMutateParams>

export function useDesktopReportsInOrgMutate(options: Op) {
  const res = useCommonDataProvider({
    ...options,
    requestValue: POST_SCHOOL_REPORTS_LIST,
    error: 'Не удалось изменить настройки отчетов (desktop) для заведения',
    convertions: {
      convertResult,
      convertParams,
    },
    defaultState,
    autoload: false,
    autoupdate: false,
  })

  return res
}
